/* jslint browser: true */
import React, { Component } from 'react';

class CommandeFin extends Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.setState({ type: this.props.match.params.type });
    }

    goToProgram() {
        window.location.href = '/programme';
    }

    goToCommande() {
        window.location.href = '/commande';
    }

    render() {
        if (this.state.type === 'validee') {
            return (
                <div className="col-lg-12 col-sm-12">
                    <div className="lra-box">
                        <div className="lra-box-header">Commande validée</div>
                        <div className="lra-box-body">
                            <h3 style={{ textAlign: 'center' }}>
                                Votre commande a été validée et les crédits sont
                                désormais disponibles dans votre compte.
                            </h3>
                            <div style={{ textAlign: 'center' }}>
                                <button
                                    type="button"
                                    className="btn myBtn"
                                    onClick={e => this.goToProgram()}
                                >
                                    Créer un programme
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if (this.state.type === 'annulee') {
            return (
                <div className="col-lg-12 col-sm-12">
                    <div className="lra-box">
                        <div className="lra-box-header">Commande annulée</div>
                        <div className="lra-box-body">
                            <h3 style={{ textAlign: 'center' }}>
                                Votre commande n'a pas eu lieu. Contactez le
                                support s'il s'agit d'une erreur.
                            </h3>
                            <div style={{ textAlign: 'center' }}>
                                <button
                                    type="button"
                                    className="btn myBtn"
                                    onClick={e => this.goToCommande()}
                                >
                                    Commander des crédits
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        window.location.href = '/login';
    }
}

export default CommandeFin;



// WEBPACK FOOTER //
// ./src/components/commande/CommandeFin.js